// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-page-not-found-tsx": () => import("/usr/src/app/src/templates/PageNotFound.tsx" /* webpackChunkName: "component---src-templates-page-not-found-tsx" */),
  "component---src-templates-page-tsx": () => import("/usr/src/app/src/templates/Page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */),
  "component---node-modules-gatsby-source-prismic-graphql-components-preview-page-js": () => import("/usr/src/app/node_modules/gatsby-source-prismic-graphql/components/PreviewPage.js" /* webpackChunkName: "component---node-modules-gatsby-source-prismic-graphql-components-preview-page-js" */)
}

